import { OrderDto, OrderState, RolePermission } from 'desk-common';
import {
  DEFAULT_FORM_VALUES,
  FormValues,
} from './constants/orderForm.constants';
import { User } from '../../auth/authState';
import userHasPermission from '../../utils/functions/userHasPermission';

export const getOrderFormValues = (order?: OrderDto | null): FormValues => {
  if (!order) {
    return {
      ...DEFAULT_FORM_VALUES,
      items: [{ ...DEFAULT_FORM_VALUES.items[0] }],
    };
  }

  return {
    costCenterId: order.costCenterId,
    action: DEFAULT_FORM_VALUES.action,
    items: order.items.map((item) => ({
      productId: item.productId,
      quantity: item.quantity,
      price: item.unitPrice,
    })),
  };
};

export const getInitialCreateValues = (
  costCenterId: number | null
): FormValues => ({
  ...DEFAULT_FORM_VALUES,
  costCenterId,
  items: [{ ...DEFAULT_FORM_VALUES.items[0] }],
});

export const calculateOrderTotal = (
  items?: Array<{ price: number; quantity: number }>
): number => {
  if (!items?.length) {
    return 0;
  }

  return items.reduce(
    (sum, item) => sum + (item.price || 0) * (item.quantity || 0),
    0
  );
};

export const getOrderPermissions = (
  order?: OrderDto | null,
  user?: User | null
) => {
  const isOwner = order?.userCreatedId === user?.email;
  const canEditAllOrders = userHasPermission(
    user ?? null,
    RolePermission.editOrders
  );
  const canEditOwnOrders = userHasPermission(
    user ?? null,
    RolePermission.editOwnOrders
  );
  const isEdit = Boolean(order);
  const isCreate = !order;
  const isDraft = order?.state === OrderState.BORRADOR;

  const isEditable =
    isCreate ||
    (isDraft && (canEditAllOrders || (isOwner && canEditOwnOrders)));

  const isReadOnly = !isEditable;

  return {
    isEdit,
    isCreate,
    isDraft,
    isEditable,
    isReadOnly,
  };
};
